export default "__VITE_ASSET__ad8e9ca6__"